import { moduleProviderFactory } from 'core/providers';
import { ProductList, ProductEdit, ProductUpload,ProductOrderUpload, ProductPreview, ProductHistoryList, ProductHistoryPreview } from 'application/product/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.product',
                pattern: '/products',
                children: [
                    {
                        name: 'master.app.main.product.list',
                        pattern: '',
                        tabTitle: 'PRODUCT.LIST.TITLE',
                        component: ProductList,
                        data: {
                            title: 'PRODUCT.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.product.preview',
                        pattern: 'preview/:id',
                        tabTitle: 'Product Preview',
                        component: ProductPreview,
                        data: {
                            title: 'PRODUCT.EDIT.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.product.create',
                        pattern: '/create',
                        tabTitle: 'Create Product',
                        component: ProductEdit,
                        authorization: 'productCatalogSection.create',
                        data: {
                            title: 'PRODUCT.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.product.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Product',
                        component: ProductEdit,
                        data: {
                            title: 'PRODUCT.EDIT.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.product.upload',
                        pattern: '/upload',
                        tabTitle: 'Upload Products',
                        component: ProductUpload,
                        authorization: 'productCatalogSection.create',
                        data: {
                            title: 'Products'
                        },
                    },
                    {
                        name: 'master.app.main.product.order-upload',
                        pattern: '/order-upload',
                        tabTitle: 'Upload Products Ordering',
                        component: ProductOrderUpload,
                        authorization: 'productCatalogSection.create',
                        data: {
                            title: 'Products Ordering'
                        },
                    },
                    {
						name: "master.app.main.product.product-history.list",
						pattern: '/history',
                        tabTitle: 'PRODUCT_HISTORY.LIST.TITLE',
						authorization: "portalSection.read",
						component: ProductHistoryList,
						data: {
							back: "master.app.main.product.list",
							title: "PRODUCT_HISTORY.LIST.TITLE",
						},
					},
                    {
						name: "master.app.main.product.product-history.preview",
						pattern: '/history/preview/:id/previous/:previousId',
                        tabTitle: 'PRODUCT_HISTORY.LIST.TITLE',
						authorization: "portalSection.read",
						component: ProductHistoryPreview,
						data: {
							back: "master.app.main.product.list",
							title: "PRODUCT_HISTORY.LIST.TITLE",
						},
					},                                
                ]
            }
        ],
        menu : [
            {
                title: 'MENU.FACILITY_ORDERS',
                order: 5,
                icon: 'package',
                authorization: 'coreUserSection.read',
                subMenu: [
                    {
                        title: 'MENU.PRODUCTS',
                        route: 'master.app.main.product.list',
                        order: 11,
                    }                    
                ]
            }
        ]
    });
})();

